import { render, staticRenderFns } from "./UrlForm.vue?vue&type=template&id=087a0dd1&scoped=true"
import script from "./UrlForm.vue?vue&type=script&lang=js"
export * from "./UrlForm.vue?vue&type=script&lang=js"
import style0 from "./UrlForm.vue?vue&type=style&index=0&id=087a0dd1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087a0dd1",
  null
  
)

export default component.exports